import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import useTokenExpiryCheck from "../../utils/UseTokenExpiryCheck";

const Attendance = () => {
  

  useTokenExpiryCheck();
  return (
    <div className="flex">
      {/* Main content area */}
      <div className="container mx-auto px-4 py-8 flex-1">
        <h1 className="text-2xl font-bold mb-6">Student Attendance</h1>
        <div className="bg-white shadow-md rounded-lg p-6">
          <p>Attendance records will be displayed here.</p>
        </div>
      </div>
    </div>
  );
};

export default Attendance;
